import * as denormalized from './denormalizers'
import * as constants from './constants'
import * as objects from './documentCreatedUpdated'

/**
 * Checks 2 objects for equality. 
 * @param {*} object1 
 * @param {*} object2 
 * @param {*} options 
 * @returns 
 */
function deepEqual(object1, object2, options = { removeEmptyProps: true }) {
  if (!isObject(object1) || !isObject(object2)) {
    return object1 == object2
  }

  if (options.removeEmptyProps === true) {
    cleanObject(object1)
    cleanObject(object2)
  }

  const keys1 = Object.keys(object1)
  const keys2 = Object.keys(object2)

  if (keys1.length !== keys2.length) {
    return false
  }

  for (const key of keys1) {
    const val1 = object1[key] 
    const val2 = object2[key]
    
    const areObjects = isObject(val1) && isObject(val2)
    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false
    }
  }
  return true
}


function goclone(source) {
  if (Object.prototype.toString.call(source) === '[object Array]') {
      var clone = [];
      for (var i=0; i<source.length; i++) {
          clone[i] = goclone(source[i]);
      }
      return clone;
  } else if (typeof(source)=="object") {
      var clone = {};
      for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
              clone[prop] = goclone(source[prop]);
          }
      }
      return clone;
  } else {
      return source;
  }
}


function isObject(object) {
  return object != null && typeof object === 'object'
}

function cleanObject(obj) {
  for (let propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName]
    }
    if (typeof obj[propName] === 'string' && obj[propName].length === 0) {
      delete obj[propName]
    }
  }
}

export { denormalized, constants, objects, deepEqual, goclone }